import { addAsync as _addAsync, getAsync as _getAsync } from "../api";

const BASE_URL = "/conversations";

const getUrl = (conversationSid) => `${BASE_URL}/${conversationSid}/participants`;

const participantTypes = { SMS: "SMS", CHAT: "CHAT" };

export async function createAsyncSMS({ conversationSid, phoneNumber }) {
    return _addAsync({ url: getUrl(conversationSid), data: { type: participantTypes.SMS, phoneNumber } });
}

export async function createAsyncCHAT({ conversationSid, identity }) {
    return _addAsync({ url: getUrl(conversationSid), data: { type: participantTypes.CHAT, identity } });
}

export async function readAsync({ conversationSid, sid }) {
    return _getAsync({ url: `${getUrl(conversationSid)}/${sid}` });
}
